"use client";

import React from "react";
import { Plate } from "@udecode/plate-common";
import type { TElement } from "@udecode/plate-common";
import { plugins } from "@/components/cms/ContentEditor/lib/plate-plugins";
import { Editor } from "@/components/cms/ContentEditor/components/Editor";

export default function EditedContent({
	value,
}: {
	readonly value: TElement[];
}) {
	return (
		<section className="rte-content">
			<Plate readOnly plugins={plugins} initialValue={value}>
				<Editor
					className="hmc-body-m text-systemInfo !overflow-x-hidden"
					focusRing={false}
					variant="ghost"
					size="md"
					data-testid="rte-content"
				/>
			</Plate>
		</section>
	);
}
